<template>
  <div>
    <div
      :id="`gridStatusCell${data.id}`"
      ref="gridStatusCell"
      v-closable="{
        exclude: ['gridStatusCell'],
        handler: 'closeTooltip'
      }"
      class="grid-status-cell"
      @click="onCustomOpen"
    >
      <ejs-tooltip
        v-if="data"
        :id="`gridTooltipStatusCell${data.id}`"
        ref="tooltip"
        :before-render="setSelectedTemplate"
        :content="statusToolTip"
        css-class="customtip"
        position="BottomCenter"
        opens-on="Custom"
      >
        <span v-if="data.active">
          <font-awesome-icon
            :icon="['fas', 'circle']"
            size="xs"
            class="success"
            transform="shrink-4"
          />
          Active
          <font-awesome-icon
            :icon="['far', 'chevron-down']"
            size="xs"
          />
        </span>
        <span
          v-else
        >
          <font-awesome-icon
            :icon="['fas', 'circle']"
            size="xs"
            class="danger"
            transform="shrink-4"
          />
          Inactive
          <font-awesome-icon
            :icon="['far', 'chevron-down']"
            size="xs"
          />
        </span>
      </ejs-tooltip>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import StatusTooltip from '../Tooltips/StatusTooltip'

export default {
  data () {
    return {
      data: {},
      statusToolTip () {
        return {
          template: StatusTooltip
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'getGridSelectedTemplate'
    ])
  },
  methods: {
    setSelectedTemplate () {
      this.$store.commit('SET_GRIDSELECTEDTEMPLATE', this.data)
    },
    onCustomOpen (args) {
      if (args.target.getAttribute('data-tooltip-id')) {
        this.$refs.tooltip.close()
      } else {
        this.$refs.tooltip.open(args.target)
      }
    },
    closeTooltip () {
      this.$refs.tooltip.close()
    }
  }
}
</script>

<style lang="scss" scoped>
.grid-status-cell {
  float: left;
  &:hover {
    cursor: pointer;
  }
}
a.tooltip-link, .link-default {
  text-decoration: none;
  color: #666;
}
.success {
  color: $success;
}
.danger {
  color: $danger;
}
.unset {
  color: $gray-medium;
}
.svg-inline--fa {
  vertical-align: 0;
}
</style>
